import { UnAuthenticatedRoutes } from "./navigation/UnauthenticatedRoutes";

export const AppUnauthenticated = () => {
	return <UnAuthenticatedRoutes />;
};
